import { Col, Container, Row } from "react-bootstrap"
import { useParams } from "react-router"
import PurchaseEntry from "../../../Components/Purchases/PurchaseEntry"
import { bClientApi, useCancelPaymentIntentMutation, useCapturePaymentIntentMutation, useGetPurchaseByIdQuery } from "../../../services/bClientApi"
import { useState } from "react"
import { ConfirmModal } from "../../../Components/Modals/confirmModal"
import { useAppDispatch } from "../../../redux/store"
import { showError, showSuccess } from "../../../redux/counter/counterSlice"

export default function PurchasePage() {
  const { purchaseId = '' } = useParams()
  const dispatch = useAppDispatch()

  const [capturePaymentIntent, { isLoading: isCapturing }] = useCapturePaymentIntentMutation()
  const [cancelPaymentIntent, { isLoading: isCanceling }] = useCancelPaymentIntentMutation()
  
  const [showCaptureModal, setShowCaptureModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)

  const {
    data,
    error,
    isLoading,
    // refetch
  } = useGetPurchaseByIdQuery(purchaseId, { skip: !purchaseId })
  const purchaseData = data || {}



  const shouldShowPaymentButtons = 
    purchaseData.merchant === 'stripe' && 
    purchaseData.paymentStatus === 'unpaid' && 
    purchaseData.sessionStatus === 'complete'

  const handleCapturePayment = async () => {
    try {
      await capturePaymentIntent(purchaseData.paymentIntent).unwrap()
      setShowCaptureModal(false)
      dispatch(showSuccess('Payment captured successfully!'))
      setTimeout(() => {
        console.log('Refetching purchase data...')
        dispatch(bClientApi.util.invalidateTags(['Purchase']))
      }, 3000)
    } catch (error) {
      dispatch(showError((error as any)?.data?.error || 'Error capturing payment'))
    }
  }

  const handleCancelPayment = async () => {
    try {
      await cancelPaymentIntent(purchaseData.paymentIntent).unwrap()
      setShowCancelModal(false)
      dispatch(showSuccess('Payment canceled successfully!'))
      setTimeout(() => {
        console.log('Refetching purchase data...')
        // refetch()
        dispatch(bClientApi.util.invalidateTags(['Purchase']))
      }, 3000)
    } catch (error) {
      dispatch(showError((error as any)?.data?.error || 'Error canceling payment'))
    }
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Single Purchase Page</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          {purchaseId && purchaseData && !isLoading && (
            <div className="purchaseinfo">
              {/* <pre>
                {JSON.stringify(purchaseData, null, 2)}            
              </pre> */}
              <PurchaseEntry
                purchaseData={purchaseData}
                fullView={true}
              />

              {shouldShowPaymentButtons && (
                <div className="payment-actions mt-3 mb-3">
                  <button 
                    className="btn btn-success me-2"
                    onClick={() => setShowCaptureModal(true)}
                    disabled={isCapturing || isCanceling}
                  >
                    {isCapturing ? 'Capturing...' : 'Capture Payment Intent'}
                  </button>
                  <button 
                    className="btn btn-danger"
                    onClick={() => setShowCancelModal(true)}
                    disabled={isCapturing || isCanceling}
                  >
                    {isCanceling ? 'Canceling...' : 'Cancel Payment Intent'}
                  </button>
                </div>
              )}
            </div>
          )}
        </Col>
      </Row>

      <ConfirmModal
        active={showCaptureModal}
        onClose={() => setShowCaptureModal(false)}
        onConfirm={handleCapturePayment}
        title="Capture Payment Intent"
        message="Are you sure you want to capture this payment intent? This action cannot be undone."
        disabled={isCapturing}
      />

      <ConfirmModal
        active={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onConfirm={handleCancelPayment}
        title="Cancel Payment Intent"
        message="Are you sure you want to cancel this payment intent? This action cannot be undone."
        disabled={isCanceling}
      />
    </Container>
  )
}
